import React from "react";

const logo = `${process.env.REACT_APP_ASSETS_PATH}/images/emma_logo.png`;

const Logo = () => (
  <img src={logo} alt="EMMA" title="EMMA" className="emma-logo" />
);

export default Logo;
